import { NavigationGroup } from "./NavigationGroup/NavigationGroup.jsx";
import { styles } from "./HighLevelNavigation.css.ts";

/**
 * HighLevelNavigation is a functional component for rendering a navigation interface with multiple phases and stages.
 *
 * @param {Object} props - The props object for the component.
 * @param {Array} props.phases - The array of phase objects to render in the navigation.
 * @param {Object} props.currentPhase - The currently selected phase object.
 * @param {Object} props.currentStage - The currently selected stage within a phase.
 * @param {Function} props.handleStageClick - The function to update the current position.
 * @param {boolean} [props.disableSome=false] - A flag to optionally disable some functionality in the navigation.
 *
 * @returns {JSX.Element} A JSX element representing the high-level navigation component.
 */
export const HighLevelNavigation = ({
  phases,
  currentPhase,
  currentStage,
  handleStageClick,
  disableSome = false,
}) => {
  return (
    <div className={styles.highLevelNavigation} id="higher-level-navigation">
      {Array.isArray(phases) &&
        phases.map((phase) => (
          <NavigationGroup
            phase={phase}
            currentPhase={currentPhase}
            currentStage={currentStage}
            handleStageClick={handleStageClick}
            disableSome={disableSome}
            key={phase.name}
          />
        ))}
    </div>
  );
};
